import { useState, useEffect } from 'react'

import { useEventFeedsContext } from '../../context/index.jsx'

import { updateEventFeed } from '_services/data-explorer'
import { logErrorAsync } from '../../../../lib/utility.js'

const INITIAL_STATE = []

const SCHEMA = { type: 'custom_iscore', terms: [], alias: '', lookupMethod: '' }

const useCustomAttributesCRUD = ({ onSave = () => {}, saveOnDelete = false }) => {
  const { data, dispatch, ACTIONS, id: feedId } = useEventFeedsContext()
  const [customAttributes, setCustomAttributes] = useState(INITIAL_STATE)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setCustomAttributes(data.customAttributes)
  }, [data])

  const validate = (customAttribute) => {
    if (!customAttribute?.alias) {
      toast.error('You must provide a name.')
      return false
    }

    return true
  }

  const handleSaveChanges = async () => {
    if (!customAttributes.every((ca) => validate(ca))) {
      return
    }

    setIsLoading(true)
    const newData = {
      ...data,
      customAttributes,
    }

    try {
      const response = await updateEventFeed(feedId, newData)
      dispatch({
        type: ACTIONS.SET_DATA,
        payload: response,
      })
      toast('Changes saved')
      onSave()
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }

    setIsLoading(false)
  }

  const handleAdd = () => {
    if (customAttributes.some((val) => val.alias === '')) {
      setSelectedTabIndex(customAttributes.findIndex((val) => val.alias === ''))
      return
    }
    setCustomAttributes((cas) => [...cas, SCHEMA])
    setSelectedTabIndex(customAttributes.length)
  }

  const handleEdit = (id, value) => {
    setCustomAttributes((cas) => {
      const newState = cas.map((ca, index) => (index === id ? value : ca))
      return newState
    })
  }

  const handleRemove = (id) => {
    setCustomAttributes((prevState) => {
      const newState = prevState.filter((filter, index) => !(index === id))
      if (saveOnDelete) {
        handleSaveChanges(newState)
      }
      return newState
    })
  }

  const handleSelect = (event) => {
    setSelectedTabIndex(Number(event.currentTarget.value))
  }

  return {
    handleSaveChanges,
    handleAdd,
    handleEdit,
    handleRemove,
    handleSelect,
    selectedTabIndex,
    isLoading,
    customAttributes,
  }
}

export default useCustomAttributesCRUD
